"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _invoke = _interopRequireDefault(require("lodash/invoke"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _mobxReact = require("mobx-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactDropzone = _interopRequireDefault(require("react-dropzone"));
var _cloudinaryUtils = require("../../utils/cloudinary-utils");
var _fileUtils = require("../../utils/file-utils");
var _mediaUtils = require("../../utils/media-utils");
var _FormattedComponents = require("../FormattedComponents");
var _styles = require("./styles");
var _messages = _interopRequireDefault(require("./messages"));
var _constants = require("./constants");
var _dec, _class, _MediaUploaderComponent; //helpers
//components
//styles
//messages
//constants
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TWENTY_MB = 20 * 1024 * 1024;
var MediaUploaderComponent = (_dec = (0, _mobxReact.inject)('store'), _dec(_class = (_MediaUploaderComponent = /*#__PURE__*/function (_Component) {
  function MediaUploaderComponent() {
    var _this;
    _classCallCheck(this, MediaUploaderComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MediaUploaderComponent, [].concat(args));
    _defineProperty(_this, "axiosRequestToken", null);
    _defineProperty(_this, "fileReaderToken", null);
    _defineProperty(_this, "isUnmounted", false);
    _defineProperty(_this, "lastAcceptedFile", null);
    _defineProperty(_this, "state", {
      isUploading: false,
      progress: 0
    });
    _defineProperty(_this, "cancelPendingRequest", function () {
      (0, _invoke["default"])(_this.axiosRequestToken, 'cancel');
      (0, _invoke["default"])(_this.fileReaderToken, 'cancel');
    });
    _defineProperty(_this, "handleDropAccepted", function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        file = _ref2[0];
      var _this$props = _this.props,
        onUploadStart = _this$props.onUploadStart,
        onChange = _this$props.onChange,
        onError = _this$props.onError;
      // Max size 20MB
      if (file.size > TWENTY_MB) {
        onError({
          type: 'fileSizeError'
        });
        return;
      }
      var _resourceAllowed = (0, _mediaUtils.resourceAllowed)(file, _constants.ALLOW_VIDEOS, _constants.ALLOWED_FILE_TYPES),
        allowed = _resourceAllowed.allowed,
        error = _resourceAllowed.error;
      if (allowed) {
        _this.lastAcceptedFile = file;
        onUploadStart();
        _this.upload(file)["catch"](function () {
          return onError({
            type: 'networkError'
          });
        })["finally"](function () {
          var onUploadEnd = _this.props.onUploadEnd;
          onUploadEnd();
        });
      } else {
        onError(error);
      }
    });
    _defineProperty(_this, "handleDropzoneClick", function (event) {
      // Allow opening the file dialog by clicking the entire control only
      // when no image is selected:
      if (_this.readyState !== _constants.READY_STATE.EMPTY) {
        event.preventDefault();
      }
    });
    _defineProperty(_this, "handleResetClick", function (event) {
      var onBeforeRemove = _this.props.onBeforeRemove;
      onBeforeRemove().then(function () {
        return _this.props.onChange(undefined);
      }, function () {
        /* catch, but do nothing */
      });
      event.stopPropagation();
    });
    _defineProperty(_this, "handleUploadProgress", function (event) {
      _this.setState({
        progress: event.loaded / event.total
      });
    });
    _defineProperty(_this, "retry", function () {
      if (_this.lastAcceptedFile) {
        _this.handleDropAccepted([_this.lastAcceptedFile]);
      }
    });
    _defineProperty(_this, "upload", function (file) {
      var store = _this.props.store;
      var platform = store.platform;
      _this.setState({
        isUploading: true,
        progress: 0
      });
      _this.axiosRequestToken = _axios["default"].CancelToken.source();
      _this.fileReaderToken = (0, _fileUtils.readFileAsDataURL)(file);
      var promise = _this.fileReaderToken.promise.then(function (base64) {
        var params = {
          file: base64,
          folder: platform.assetsFolder,
          upload_preset: 'unsigned'
        };
        return _axios["default"].post((0, _cloudinaryUtils.getCloudinaryApiUrl)(), params, {
          cancelToken: _this.axiosRequestToken.token,
          onUploadProgress: _this.handleUploadProgress
        });
      }).then(function (_ref3) {
        var data = _ref3.data;
        var onChange = _this.props.onChange;
        onChange(data.secure_url);
      })["catch"](function (error) {
        if (!error || _axios["default"].isCancel(error)) {
          return;
        }
        throw error;
      });
      promise["finally"](function () {
        if (!_this.isUnmounted) {
          _this.setState({
            isUploading: false
          });
        }
      });
      return promise;
    });
    return _this;
  }
  _inherits(MediaUploaderComponent, _Component);
  return _createClass(MediaUploaderComponent, [{
    key: "readyState",
    get: function get() {
      var value = this.props.value;
      var isUploading = this.state.isUploading;
      if (isUploading) {
        return _constants.READY_STATE.LOADING;
      }
      if (value) {
        return _constants.READY_STATE.DONE;
      }
      return _constants.READY_STATE.EMPTY;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value) {
        this.cancelPendingRequest();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.isUnmounted = true;
      this.cancelPendingRequest();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        dropzoneRef = _this$props2.dropzoneRef,
        value = _this$props2.value,
        isDesktop = _this$props2.isDesktop;
      var progress = this.state.progress;
      var isImage = (0, _mediaUtils.isImageUrl)(value);
      return /*#__PURE__*/_react["default"].createElement(_reactDropzone["default"], {
        accept: _constants.ALLOWED_FILE_TYPES,
        disabled: this.readyState === _constants.READY_STATE.LOADING,
        multiple: false,
        onClick: this.handleDropzoneClick,
        onDropAccepted: this.handleDropAccepted,
        ref: dropzoneRef
      }, function (_ref4) {
        var getRootProps = _ref4.getRootProps,
          getInputProps = _ref4.getInputProps,
          open = _ref4.open;
        return /*#__PURE__*/_react["default"].createElement(_styles.MediaUploader, _extends({
          isImage: !value || isImage,
          backgroundURL: isImage ? value : undefined,
          isDesktop: isDesktop,
          readyState: _this2.readyState
        }, getRootProps({
          refKey: 'innerRef'
        })), value && !isImage && /*#__PURE__*/_react["default"].createElement("video", {
          width: '100%',
          height: '100%',
          controls: true,
          preload: "metadata"
        }, /*#__PURE__*/_react["default"].createElement("source", {
          src: "".concat(value, "#t=0.1")
        })), /*#__PURE__*/_react["default"].createElement("input", getInputProps()), _this2.readyState === _constants.READY_STATE.EMPTY ? /*#__PURE__*/_react["default"].createElement(_styles.TextWrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.AddPictureIcon, null), /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].selectFile)) : _this2.readyState === _constants.READY_STATE.LOADING ? /*#__PURE__*/_react["default"].createElement(_styles.TextWrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.CircularProgressBar, {
          value: progress
        }), /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].uploadingFile), /*#__PURE__*/_react["default"].createElement(_styles.CancelButton, {
          onClick: _this2.cancelPendingRequest
        }, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].cancel))) : /*#__PURE__*/_react["default"].createElement(_styles.ControlsWrapper, {
          isImage: !value || isImage
        }, /*#__PURE__*/_react["default"].createElement(_styles.ControlButton, {
          onClick: open
        }, /*#__PURE__*/_react["default"].createElement(_styles.ControlButtonIcon, {
          name: "image-search"
        })), /*#__PURE__*/_react["default"].createElement(_styles.ControlButton, {
          onClick: _this2.handleResetClick,
          "data-testid": "ResetButton"
        }, /*#__PURE__*/_react["default"].createElement(_styles.ControlButtonIcon, {
          name: "trashbin"
        }))));
      });
    }
  }]);
}(_react.Component), _defineProperty(_MediaUploaderComponent, "defaultProps", {
  onUploadStart: _noop["default"],
  onUploadEnd: _noop["default"],
  onBeforeRemove: function onBeforeRemove() {
    return Promise.resolve();
  },
  onChange: _noop["default"],
  onError: _noop["default"]
}), _defineProperty(_MediaUploaderComponent, "propTypes", {
  dropzoneRef: _propTypes["default"].func,
  onUploadStart: _propTypes["default"].func,
  // when the uploading starts
  onUploadEnd: _propTypes["default"].func,
  // when the uploading ends
  onBeforeRemove: _propTypes["default"].func,
  // if the result rejects, won't remove
  onChange: _propTypes["default"].func,
  // when the uploading finished and the new value is passed
  onError: _propTypes["default"].func,
  value: _propTypes["default"].string
}), _MediaUploaderComponent)) || _class);
var _default = exports["default"] = MediaUploaderComponent;
//# sourceMappingURL=index.js.map